import { isNumber, isString } from '@antv/util';
import { Text } from '../shapes';
export function renderExtDo(el) {
    if (typeof el === 'function')
        return el();
    return isString(el) || isNumber(el) ? new Text({ style: { text: String(el) } }) : el;
}
//# sourceMappingURL=extend-display-object.js.map